import React, { useState, useEffect } from 'react';
import { useAuthenticatedUser } from '../../../../authentication';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { ReassignCasesRequest } from '../../../../api-service/clients';
import { AssignCasesCaseworkerDialogComponent } from './assign-cases-caseworker-dialog-component';

export interface ICasesAssignCaseworkerDialogProps {
  caseIds: string[];
  onCompleted?: () => void;
}

export function AssignCasesCaseworkerDialog({ caseIds, onCompleted }: ICasesAssignCaseworkerDialogProps) {
  const [userId, setUserId] = useState<string | undefined>();
  const [teamId, setTeamId] = useState<string | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const [isLoading, setIsLoading] = useState(false);

  const currentUserId = useAuthenticatedUser()?.profile.id;
  async function setTeamForUserId(id: string | undefined) {
    if (id) {
      const organizationClient = moduleClientFactory.createOrganizationClient(true);
      const response = await organizationClient.getUserById({ userId: id });
      setTeamId(response.user?.teamId);
    } else {
      setTeamId(undefined);
    }
  }

  useEffect(() => {
    if (isOpen) {
      setIsLoading(false);

      setUserId(currentUserId);

      if (currentUserId) {
        setTeamForUserId(currentUserId);
      }
    }
  }, [currentUserId, isOpen]);

  async function handleConfirm() {
    const request: ReassignCasesRequest = {
      caseWorkerId: userId || '',
      caseIds,
      teamId: teamId ?? '',
    };

    async function reassignCasesAsync() {
      await moduleClientFactory.createCitizenCaseClient().reassignCases(request);
    }

    setIsLoading(true);
    try {
      await reassignCasesAsync();
      onCompleted?.();
    } finally {
      setIsOpen(false);
    }
  }

  const handleTeamChange = (value: string | undefined) => {
    setTeamId(value);
    setUserId(undefined);
  };

  const handleUserChange = async (selectedUserId: string | undefined) => {
    setUserId(selectedUserId);

    await setTeamForUserId(selectedUserId ?? currentUserId);
  };
  function handleClose() {
    setIsOpen(false);
  }
  if (!isOpen) {
    return null;
  }

  return (
    <AssignCasesCaseworkerDialogComponent
      onConfirm={handleConfirm}
      onTeamChange={handleTeamChange}
      onUserChange={handleUserChange}
      teamId={teamId}
      userId={userId}
      isOpen={isOpen}
      onClose={handleClose}
      isLoading={isLoading}
    />
  );
}
